<template>
  <div class="c-home__section__fade u-relative o-wrapper--panel o-wrapper--valign u-fit">
    <div class="c-selector__canvas u-absolute u-pos-tl u-fit js-canvas">

    </div>
    <div class="c-home__grain o-wrapper--panel u-fit u-pointer-none"></div>
     <div class="c-selector__links u-relative u-inline-block u-valign-middle u-align-left <u-pad-x-md@sm></u-pad-x-md@sm>">
       <div class="u-force-3d u-relative t-text--sm t-text--base-bold u-block u-color--gray u-marg-b-vh1of20">
            {{content.sixth_slide_subtitle}}

              <div class="c-selector__number u-absolute t-text--sm t-text--base-bold u-color--alpha-white u-marg-r-lg">
                  06
              </div>
            </div>
             <span class="c-selector__item-wrapper u-block" @mouseover="onItemOver('left')"   @mouseout="onItemOut('left')">
                  <router-link  to="/borrowers"    class="c-selector__item t-h1 t-text--roman t-link u-inline-block" :class="{'is-disable':activeItemPosition==='right'}">
                      <div class="c-selector__item__base u-color--gray"> {{content.sixth_slide_title_top}}</div>
                      <div class="c-selector__item__hover o-wrapper--panel u-fit u-color--brand-blue-light">{{content.sixth_slide_title_top}}</div>
                  </router-link>
             </span>
           <span class="u-force-3d t-text--sm u-block u-color--gray u-marg-t-lg u-marg-b-md">or</span>
              <span class="c-selector__item-wrapper u-block">
                  <router-link  to="/investors"    class="c-selector__item t-h1 t-text--roman t-link u-inline-block" :class="{'is-disable':activeItemPosition==='left'}">
                  <div class="c-selector__item__base u-color--gray">{{content.sixth_slide_bottom_title}}</div>
                  <div class="c-selector__item__hover o-wrapper--panel u-fit u-color--brand-blue-light">{{content.sixth_slide_bottom_title}}</div>
                </router-link>
              </span>
            </div>
          </div>
</template>
<script>
import Pixi from 'pixi.js'
export default {
  name: "app-home-solutions-selector",
                 props: {
                   debug: {
                       type: Boolean,
                       default: !1
                   },
                     content: {
                         type: Object,
                         default: function() {}
                     },
                     isActive: {
                         type: Boolean,
                         default: !1
                     }
                 },
                 data: function() {
                     return {
                         activeItemPosition: "center"
                     }
                 },
                 watch: {
                     isActive: "moveContainer"
                 },
                 created: function() {
                   this.isShown = !1,
                   this.baseWinWidth = this.$root.winWidth,
                   this.baseWinHeight = this.$root.winHeight,
                   this.tilesWidth = .3 * this.$root.winWidth,
                   this.tilesWidth = this.tilesWidth < 200 ? 200 : this.tilesWidth > 400 ? 400 : this.tilesWidth, this.tilesRotation = 25,
                   this.maskOffsetX = 40,
                    this._stagePositionX = -100,
                     this.scene = {
                       container: null,
                       position: {
                           x: 0,
                           y: 0
                       },
                       graphics: {
                           left: null,
                           right: null
                       },
                       mask: {
                           left: {
                               image: "/assets/medias/images/borrowers-header.jpg",
                               container: null,
                               texture: null,
                               sprite: null,
                               tween: null,
                               graphic: null
                           },
                           right: {
                               image: "/assets/medias/images/investors-header.jpg",
                               container: null,
                               texture: null,
                               sprite: null,
                               tween: null,
                               graphic: null
                           }
                       }
                   },
                   this.onResize = this.onResize.bind(this),
                   this.onEnterframe = this.onEnterframe.bind(this),
                   this.eventHub.$on("resize", this.onResize),
                    this.eventHub.$on("enterframe", this.onEnterframe)
               },
               destroyed: function() {
                   this.eventHub.$off("resize", this.onResize),
                   this.eventHub.$off("enterframe", this.onEnterframe)
               },
               mounted: function() {
                   this.loaded = !0,
                    this.initScene()
               },
               methods: {
                   moveContainer: function() {
                       var t = this;
                       setTimeout(function() {
                           var e = t.isActive ? t._stagePositionX : 0,
                               n = t.isActive ? 0 : t._stagePositionX;
                           t._tweenX.stop().clear(), t._tweenX.time = 3450, t._tweenX.easing = r.tween.Easing.outQuint(), t._tweenX.from({
                               x: e
                           }), t._tweenX.to({
                               x: n
                           }), t._tweenX.loop = !1, t._tweenX.start()
                       }, 50)
                   },
                   loadTextures: function() {
                       var t = this,
                           e = new PIXI.loaders.Loader();
                       Object.keys(this.scene.mask).map(function(n, r) {
                           var i = t.scene.mask[n];
                           i.image && e.add(i.image, i.image)
                       }),
                        e.load(),
                        this.eventHub.$emit("loader:start", 2),
                       e.on("progress", function() {
                           t.eventHub.$emit("loader:progress")
                       }), e.once("complete", function() {
                           t.loaded = !0, t.initScene()
                       })
                   },
                   initScene: function()
                   {
                       var t = this;
                       this._renderer = PIXI.autoDetectRenderer(this.$root.winWidth, this.$root.winHeight, {
                           backgroundColor: 1777445,
                           antialias: !1
                       }),

                       this._stage = new PIXI.Container(),
                       this._stage.position.x = this._stagePositionX,
                       this._tweenX = PIXI.tweenManager.createTween(this._stage),
                       this.scene.container = new PIXI.Container(),
                       this.scene.container.position.x = this.scene.position.x,
                        this.scene.graphics.right = new PIXI.Graphics(),
                         this.scene.graphics.right.beginFill(2830132),
                          this.scene.graphics.right.alpha = 1,
                          this.scene.graphics.right.drawRect(0, 0, this.tilesWidth, 2 * this.$root.winHeight),
                           this.scene.graphics.right.position.x = this.$root.winWidth / 2,
                           this.scene.graphics.right.pivot.set(this.tilesWidth / 2, 0),
                           this.scene.graphics.right.rotation = this.tilesRotation * Math.PI / 180 + Math.PI,
                           this.scene.graphics.right.position.y = this.$root.winHeight + (this.tilesWidth / 100 * 10 + 2 * this.tilesRotation),
                            this.scene.graphics.right.endFill(),
                            this.scene.graphics.left = new PIXI.Graphics(),
                            this.scene.graphics.left.beginFill(2172203),
                            this.scene.graphics.left.alpha = 1,
                             this.scene.graphics.left.drawRect(0, 0, this.tilesWidth, 2 * this.$root.winHeight),
                              this.scene.graphics.left.position.x = this.$root.winWidth / 2,
                              this.scene.graphics.left.pivot.set(this.tilesWidth / 2, 0),
                              this.scene.graphics.left.rotation = this.tilesRotation * Math.PI / 180 * -1 + Math.PI,
                              this.scene.graphics.left.position.y = this.$root.winHeight + (this.tilesWidth / 100 * 10 + 2 * this.tilesRotation),
                              this.scene.graphics.left.endFill(),
                               this.scene.container.addChild(this.scene.graphics.left),
                               this.scene.container.addChild(this.scene.graphics.right),
                                Object.keys(this.scene.mask).map(function(e, n) {
                           var i = t.scene.mask[e];
                           i.image && (i.container = new PIXI.Container(),
                              i.texture = new PIXI.Texture.fromImage(i.image),
                           i.sprite = new PIXI.Sprite(i.texture),
                           i.spriteScale = t.$root.winWidth / i.sprite.width >= t.$root.winHeight / i.sprite.height ? t.$root.winWidth / i.sprite.width : t.$root.winHeight / i.sprite.height,
                           i.sprite.scale.x = i.spriteScale, i.sprite.scale.y = i.spriteScale,
                           i.sprite.position.x = (t.$root.winWidth - i.sprite.width) / 2,
                           i.sprite.position.y = (t.$root.winHeight - i.sprite.height) / 2,
                           i.sprite.alpha = 0,
                            i.sprite.mask = null,
                            "right" === e ? (i.sprite.position.x -= t.maskOffsetX, i.graphic = new PIXI.Graphics(), i.graphic.beginFill(2567221),
                            i.graphic.alpha = 0,
                            i.graphic.drawRect(0, 0, t.tilesWidth, 2 * t.$root.winHeight),
                            i.graphic.position.x = t.$root.winWidth / 2,
                            i.graphic.pivot.set(t.tilesWidth / 2, 0),
                            i.graphic.rotation = t.tilesRotation * Math.PI / 180 + Math.PI,
                             i.graphic.position.y = t.$root.winHeight + (t.tilesWidth / 100 * 10 + 2 * t.tilesRotation),
                              i.graphic.endFill()) : "left" === e && (i.sprite.position.x += t.maskOffsetX, i.graphic = new PIXI.Graphics(), i.graphic.beginFill(2172461),
                               i.graphic.alpha = 0, i.graphic.drawRect(0, 0, t.tilesWidth, 2 * t.$root.winHeight),
                               i.graphic.position.x = t.$root.winWidth / 2, i.graphic.pivot.set(t.tilesWidth / 2, 0),
                               i.graphic.rotation = t.tilesRotation * Math.PI / 180 * -1 + Math.PI,
                                i.graphic.position.y = t.$root.winHeight + (t.tilesWidth / 100 * 10 + 2 * t.tilesRotation),
                                 i.graphic.endFill()),
                                 i.tween = r.tweenManager.createTween(i.sprite),
                                 i.container.addChild(i.sprite),
                                 i.container.addChild(i.graphic),
                                 t.scene.container.addChild(i.container))
                       }), this._stage.addChild(this.scene.container),
                        document.querySelector(".js-canvas").appendChild(this._renderer.view)
                   },
                   onResize: function()
                    {
                      this.debug&&console.log('app-home-solutions-select OnResize method start');
                       var t = this.$root.winWidth,
                           e = this.$root.winHeight;
                       t / this.baseWinWidth > e / this.baseWinHeight ? this.baseWinHeight : this.baseWinWidth;
                       this._stage.scale.x = t / this.baseWinWidth,
                       this._stage.scale.y = e / this.baseWinHeight,
                       this._renderer.resize(t, e)
                       this.debug&&console.log('app-home-solutions-select OnResize method End');
                   },
                   onEnterframe: function()
                    {
                       this.isActive && (this.isShown || this.onEnterSlide(), PIXI.tweenManager.update(), this.loaded && this._renderer.render(this._stage))
                   },
                   onEnterSlide: function()
                   {
                       this.isShown = !0
                   },
                   onItemOver: function(t)
                   {
                       this.activeItemPosition = t,
                        this.scene.mask[t].sprite.mask = this.scene.mask[t].graphic,
                        this.scene.mask[t].tween.stop().clear(),
                        this.scene.mask[t].tween.time = 1950,
                        this.scene.mask[t].tween.easing = r.tween.Easing.outQuint();
                       var e = "left" === t ? (this.$root.winWidth - this.scene.mask[t].sprite.width) / 2 + this.maskOffsetX : (this.$root.winWidth - this.scene.mask[t].sprite.width) / 2 - this.maskOffsetX;
                       this.scene.mask[t].tween.from({
                           x: this.scene.mask[t].sprite.position.x,
                           alpha: this.scene.mask[t].sprite.alpha
                       }),
                       this.scene.mask[t].tween.to({ x: e,alpha: .5 }),
                        this.scene.mask[t].tween.loop = !1,
                        this.scene.mask[t].tween.start(),
                        this._tweenX.stop().clear(),
                        this._tweenX.time = 1950,
                        this._tweenX.easing = r.tween.Easing.outQuint(),
                        this._tweenX.from({ x: this._stage.position.x }),
                        this._tweenX.to({ x: "left" === t ? 2 * -this.maskOffsetX : 2 * this.maskOffsetX }),
                        this._tweenX.loop = !1,
                        this._tweenX.start()
                   },
                   onItemOut: function(t)
                   {
                       this.activeItemPosition = "center",
                       this.scene.mask[t].tween.stop().clear(),
                       this.scene.mask[t].tween.time = 1950,
                       this.scene.mask[t].tween.easing = r.tween.Easing.outQuint(),
                        this.scene.mask[t].tween.from({ x: this.scene.mask[t].sprite.position.x,   alpha: this.scene.mask[t].sprite.alpha}),
                        this.scene.mask[t].tween.to({ x: (this.$root.winWidth - this.scene.mask[t].sprite.width) / 2,   alpha: 0 }),
                       this.scene.mask[t].tween.loop = !1,
                       this.scene.mask[t].tween.start(),
                       this._tweenX.stop().clear(),
                       this._tweenX.time = 1950,
                        this._tweenX.easing = r.tween.Easing.outQuint(),
                         this._tweenX.from({  x: this._stage.position.x }),
                         this._tweenX.to({   x: 0 }),
                         this._tweenX.loop = !1,
                         this._tweenX.start()
                   }
               }
}
</script>
<style  scoped>
</style>



// WEBPACK FOOTER //
// src/components/app-home-solutions-selector/index.vue